import { observable, action, computed } from "mobx";
import { BaseListStore, BaseListState } from "./BaseListStore";

import { HorseForSaleEndpoints } from "../endpoints/HorseForSaleEndpoints";

import { HorseGait } from "src/model/Horse";
import { SimpleHorseForSale, HorseSale } from "../model/HorseForSale";
import { ListWrapper, EmptyWrapper } from "../model/ListWrapper";
import { SimpleCustomer } from "src/model/Customer";

const FIRST_PAGE: number = 1;
const DEFAULT_SIZE_PER_PAGE: number = 10;

export interface HorseForSaleListFilters {
    selectedGaits: Array<HorseGait>;
    selectedSales: Array<HorseSale>;
    selectedStates: Array<string>;
    selectedConsignors: Array<SimpleCustomer>;
    fullTextSearch: string;
}

export interface HorseForSaleListState extends BaseListState {
    sortField?: "horseName" | "consignor" | "hipNumber";
}

export class HorseForSaleListStore extends BaseListStore<HorseForSaleListFilters, HorseForSaleListState, SimpleHorseForSale> {
    constructor(private horseForSaleEndpoints: HorseForSaleEndpoints) {
        super();
    }

    @action async deleteHorseForSale(horseForSaleId: number) {
        this.setLoading();
        try {
            await this.horseForSaleEndpoints.deleteHorseForSale(horseForSaleId);
            this.refresh();
        } catch (e) {
            throw e;
        } finally {
            this.setReady();
        }
    }

    /**
     *
     * @param filters
     * @deprecated Use updateListFilters instead
     */
    @action updateHorseForSaleListFilters(filters: Partial<HorseForSaleListFilters>) {
        this.updateListFilters(filters);
    }

    /**
     *
     * @param state
     * @deprecated Use updateListState instead
     */
    @action updateHorseForSaleListState(state: Partial<HorseForSaleListState>) {
        this.updateListState(state);
    }

    /**
     * @deprecated Use listFilters instead
     */
    @computed get horseForSaleListFilters(): HorseForSaleListFilters {
        return this.listFilters;
    }

    /**
     * @deprecated Use listState instead
     */
    @computed get horseForSaleListState(): HorseForSaleListState {
        return this.listState;
    }

    /**
     * @deprecated Use list instead
     */
    @computed get horseForSaleList(): ListWrapper<SimpleHorseForSale> {
        return this.list;
    }

    protected obtainList(): Promise<ListWrapper<SimpleHorseForSale>> {
        const state = this._listState,
            filters = this._listFilters;
        return this.horseForSaleEndpoints.getHorseForSaleList(
            state.sizePerPage,
            (state.page - 1) * state.sizePerPage,
            state.sortField && state.sortOrder ? `${state.sortField} ${state.sortOrder}` : undefined,
            {
                fullTextSearch: filters.fullTextSearch,
                gaitIds: filters.selectedGaits.map(g => g.id).join(","),
                saleIds: filters.selectedSales.map(s => s.id).join(","),
                states: filters.selectedStates.join(","),
                consignorIds: filters.selectedConsignors.map(c => c.id).join(",")
            }
        );
    }

    protected defaultFilters(): HorseForSaleListFilters {
        return {
            selectedGaits: [],
            selectedSales: [],
            selectedStates: [],
            selectedConsignors: [],
            fullTextSearch: ""
        };
    }

    protected defaultState(): HorseForSaleListState {
        // Nothing added here
        return {
            ...super.defaultState(),
            sortField: "hipNumber",
            sortOrder: "asc"
        };
    }
}



// WEBPACK FOOTER //
// ./src/stores/HorseForSaleListStore.ts